export const ERROR_CODE = {
  CL0001: 'CL0001',
  CL0002: 'CL0002',
  QR0002: 'QR0002',
}

// POST /api/web/auth/signup — the client branches on the code, never on the message
export const SIGN_UP_ERROR_CODE = {
  EMAIL_ALREADY_EXISTS: 'WEB_EMAIL_ALREADY_EXISTS',
  EMAIL_INVALID_FORMAT: 'WEB_EMAIL_INVALID_FORMAT',
  EMAIL_TOO_LONG: 'WEB_EMAIL_TOO_LONG',
  EMAIL_DOMAIN_UNDELIVERABLE: 'WEB_EMAIL_DOMAIN_UNDELIVERABLE',
  EMAIL_LOOKUP_UNAVAILABLE: 'WEB_EMAIL_LOOKUP_UNAVAILABLE',
}

export const STATUS = {
  OK: 'OK',
  ERROR: 'ERROR',
}
